module.exports = __webpack_public_path__ + "static/rankings-69b1b9de6e7daeed45ba98debe5a157d.gif";